import { Box } from '@chakra-ui/react';

import {
  REVIEW_RESPONSE_PROVIDER_TYPE_TITLE_MAP_1,
  PEER_TYPE_TAG_NAME_MAP,
  REVIEW_PROVIDER_TYPES,
  PEER_NOMINATION_COHORTS,
} from 'constants/ProjectConstants';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const ReviewerTypeTag = ({ providerType, peerType }) => {
  const isPeerProviderType =
    providerType === REVIEW_PROVIDER_TYPES.PEER && peerType && peerType !== PEER_NOMINATION_COHORTS.ALL_ORG;

  const peerTypeDisplayName = (isPeerProviderType && PEER_TYPE_TAG_NAME_MAP[peerType]) || null;

  const tagDisplayText = `${REVIEW_RESPONSE_PROVIDER_TYPE_TITLE_MAP_1[providerType]} ${
    isPeerProviderType ? `(${peerTypeDisplayName})` : ''
  }`;

  if (!providerType) {
    return null;
  }
  return (
    <Box px="8px" py="2px" bgColor="#EBEFF3" borderRadius="2px" h="24px">
      <TextBodyMedium bold>{tagDisplayText}</TextBodyMedium>
    </Box>
  );
};

export default ReviewerTypeTag;
